import useCountdown from './useCountdown';
import './Hero.css';

const HERO_PHOTO = '/photos/engagement/IMG_1639.jpg';

function Hero({ weddingDate }) {
  const countdown = useCountdown(weddingDate);
  return (
    <section className="hero">
      <div className="hero-media">
        <img className="hero-photo" src={HERO_PHOTO} alt="" />
        <div className="hero-wash" />
      </div>
      <div className="hero-content">
        <p className="hero-eyebrow">Our Story</p>
        <h1 className="hero-names">Ben&nbsp;&amp;&nbsp;Lillian</h1>
        <p className="hero-tagline">Est. 2019 · Wedding August 20, 2027</p>
        {countdown && (
          <div className="hero-countdown">
            {[
              ['days', countdown.days],
              ['hours', countdown.hours],
              ['minutes', countdown.minutes],
              ['seconds', countdown.seconds],
            ].map(([label, value]) => (
              <div key={label} className="hero-countdown-cell">
                <span className="hero-countdown-value">{String(value).padStart(2, '0')}</span>
                <span className="hero-countdown-label">{label}</span>
              </div>
            ))}
          </div>
        )}
      </div>
      <div className="hero-scroll-cue" aria-hidden="true" />
    </section>
  );
}

export default Hero;
